export default __webpack_public_path__ + "static/media/gracias.fcc0ef0b.png";